enum UploadedFileStatus {
  ERROR = 'ERROR',
  UPLOADING = 'UPLOADING',
  COMPLETE = 'COMPLETE',
}

export default UploadedFileStatus;
